var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkanSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.353 5.809c-.604-.199-1.082-.359-1.413-.582a1.109 1.109 0 01-.358-.363 1.012 1.012 0 01-.124-.518c0-.39.157-.727.439-.969.283-.243.706-.4 1.25-.4 1.097 0 1.698.611 1.963 1.275l.081.204.916-.465-.076-.173c-.435-.99-1.402-1.829-2.885-1.829-.75 0-1.435.221-1.938.634A2.208 2.208 0 00.39 4.374c0 .382.086.704.244.979.159.273.383.488.647.665.514.345 1.203.562 1.898.781l.024.007h.001c.642.198 1.158.38 1.515.623.341.233.522.512.522.924 0 .408-.152.756-.453 1.005-.306.252-.786.42-1.467.42-.665 0-1.183-.16-1.565-.42a1.946 1.946 0 01-.771-1.064l-.073-.237-.912.51.052.156c.41 1.25 1.635 2.043 3.269 2.043.86 0 1.598-.226 2.125-.646.531-.424.834-1.035.834-1.767 0-.791-.36-1.318-.914-1.699-.537-.37-1.264-.609-2.013-.845z",
    fill: "url(#skan-small_svg__paint0_linear_703_4646)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.677 2.101L9.219 6.254l4.564 4.372h-1.42L8.43 6.886v3.74H7.391V2.101h1.04v3.526L12.247 2.1h1.429z",
    fill: "url(#skan-small_svg__paint1_linear_703_4646)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.38 2.301l-3.282 8.125h.668l.814-2.073h4.212l.813 2.073h.668L18.05 2.301h-.668zm-1.539 5.492l1.888-4.707 1.86 4.707H15.84z",
    fill: "url(#skan-small_svg__paint2_linear_703_4646)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.246 2.101h.939l3.383 8.525h-1.1l-.813-2.073h-3.939l-.813 2.073h-1.101l3.444-8.525zM15.58 8.353h4.212l.813 2.073h.668L18.05 2.301h-.668l-3.283 8.125h.668l.814-2.073zm.261-.56h3.748l-1.86-4.707-1.888 4.707zm.296-.2h3.157l-1.566-3.966-1.591 3.966z",
    fill: "url(#skan-small_svg__paint3_linear_703_4646)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.361 4.075v6.551h-1.039V2.101h.855l4.665 6.55V5.884h1.039v4.743h-.855l-4.665-6.55z",
    fill: "url(#skan-small_svg__paint4_linear_703_4646)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.841 3.006h-2.15v-.933h2.15V0h1.01v2.073h2.15v.933h-2.15v2.1h-1.01v-2.1z",
    fill: "url(#skan-small_svg__paint5_linear_703_4646)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "skan-small_svg__paint0_linear_703_4646",
    x1: -3,
    y1: 5.5,
    x2: 31.5,
    y2: 8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03C1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "skan-small_svg__paint1_linear_703_4646",
    x1: -1,
    y1: 4,
    x2: 30.462,
    y2: 8.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03C1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "skan-small_svg__paint2_linear_703_4646",
    x1: -0.5,
    y1: 3,
    x2: 30.671,
    y2: 10.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03C1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "skan-small_svg__paint3_linear_703_4646",
    x1: -0.5,
    y1: 3,
    x2: 30.671,
    y2: 10.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03C1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "skan-small_svg__paint4_linear_703_4646",
    x1: -1.5,
    y1: 3,
    x2: 30.395,
    y2: 11.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03C1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "skan-small_svg__paint5_linear_703_4646",
    x1: 0,
    y1: 1.5,
    x2: 29.278,
    y2: 12.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17A39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03C1FF"
  })))));
}
export default SvgSkanSmall;